var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3.405 11.867H.867L5.89.133h1.94l5.037 11.734h-2.551L7.073 3.27l-.226-.797-.252.797z","fill":"#FFF","fillRule":"nonzero"}));
}

Arrow.defaultProps = {"width":"13","height":"12"};

module.exports = Arrow;

Arrow.default = Arrow;
